<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Financial Information</h3>
                    </div>


                    <div class="card-body">
                        <p class="card-text fs-17"><b>Existing Deposit and E-Money Accounts</b> (Please indicate Top 3 in terms of outstanding balance size)</p>
                        <p class="card-text text-justify">Do you have existing deposit and e-money accounts?</p>
                        <div class="row">
                            <div class="col-4">
                                <div class="icheck-primary d-inline">
                                    <input type="radio" id="c1" value="Y" v-model="emoneyQ">
                                    <label for="c1" :class="{ 'text-danger': submitting && $v.emoneyQ.$error }">Yes</label>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="icheck-primary d-inline">
                                    <input type="radio" id="c2" value="N" v-model="emoneyQ" @input="resetRow('emoneys')">
                                    <label for="c2" :class="{ 'text-danger': submitting && $v.emoneyQ.$error }">No</label>
                                </div>
                            </div>
                        </div>


                        <div v-if="emoneyQ=='Y'">
                            <hr />
                            <div class="row" v-for="(i, k) in emoneys" :key="k">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label :for="'ea'+k">Name of Financial Institution</label>
                                        <v-select :inputId="'ea'+k" placeholder="- Select -" append-to-body :calculate-position="withPopper" label="fin_inst_desc" :options="banks" :reduce="fin_inst_desc => fin_inst_desc.id" v-model="i.fin_inst_id"></v-select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label :for="'eb'+k">Type of Account</label>
                                        <select :id="'eb'+k" class="form-control form-control-sm" v-model="i.fin_accnt_type_id">
                                            <option :value="null">- Select -</option>
                                            <option v-for="(i, k) in category" :value="i.id" :key="k">{{i.fin_accnt_type_desc}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label :for="'ec'+k">Type of Account Ownership</label>
                                        <select :id="'ec'+k" class="form-control form-control-sm" v-model="i.fin_accnt_own_id">
                                            <option :value="null">- Select -</option>
                                            <option v-for="(i, k) in ownership" :value="i.id" :key="k">{{i.fin_accnt_own_desc}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div>
                                        <label :for="'ed'+k" class="d-block">Year Opened</label>
                                        <div role="group" class="form-group" style="display: flex; align-items: center;">
                                            <input :id="'ed'+k" type="number" class="form-control form-control-sm" v-model="i.year_opened">
                                            <button class="btn btn-sm btn-outline-danger ml-1" @click="removeRow(k, 'emoneys')" v-if="emoneys.length > 1">Remove</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-right">
                                <button class="btn btn-sm text-nowrap btn-outline-primary" @click="addRow('emoneys')">
                                    Add Row
                                </button>
                            </div>
                        </div>

                        <div>
                            <hr />
                            <p class="card-text fs-17"><b>Existing Loans</b> (Please indicate top 3 in terms of loan amount)</p>
                            <p class="card-text text-justify">Do you have existing loans?</p>
                            <div class="row">
                                <div class="col-4">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="c3" value="Y" v-model="loanQ">
                                        <label for="c3" :class="{ 'text-danger': submitting && $v.loanQ.$error }">Yes</label>
                                    </div>
                                </div>
                                <div class="col-8">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="c4" value="N" v-model="loanQ" @input="resetRow('loans')">
                                        <label for="c4" :class="{ 'text-danger': submitting && $v.loanQ.$error }">No</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="loanQ=='Y'">
                            <hr />
                            <div class="row" v-for="(i, k) in loans" :key="k">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label :for="'ln'+k">Name of Financial Institution</label>
                                        <v-select :inputId="'ln'+k" placeholder="- Select -" append-to-body :calculate-position="withPopper" label="fin_inst_desc" :options="banks" :reduce="fin_inst_desc => fin_inst_desc.id" v-model="i.fin_inst_id"></v-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label :for="'lna'+k">Loan Amount</label>
                                        <input :id="'lna'+k" type="number" class="form-control form-control-sm" v-model="i.loan_amt">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label :for="'lnb'+k">Date Granted</label>
                                        <input :id="'lnb'+k" type="date" class="form-control form-control-sm" v-model="i.date_granted" @blur="checkDate(i.date_granted, 'lnb'+k)">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label :for="'lnc'+k">Maturity Date</label>
                                        <input :id="'lnc'+k" type="date" class="form-control form-control-sm" v-model="i.date_maturity" @blur="checkDate(i.date_maturity, 'lnc'+k)">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label :for="'lnd'+k">Outstanding Balance</label>
                                        <input :id="'lnd'+k" type="number" class="form-control form-control-sm" v-model="i.fin_loan_ob">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div>
                                        <label :for="'lne'+k" class="d-block">Collaterals Offered (Optional)</label>
                                        <div role="group" class="form-group" style="display: flex; align-items: center;">
                                            <select :id="'lne'+k" class="form-control form-control-sm" v-model="i.coll_id">
                                                <option :value="null">- Select -</option>
                                                <option v-for="(i, k) in collateral" :value="i.id" :key="k">{{i.collateral}}</option>
                                            </select>
                                            <button class="btn btn-sm btn-outline-danger ml-1" @click="removeRow(k, 'loans')" v-if="loans.length > 1">Remove</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-right">
                                <button class="btn btn-sm text-nowrap btn-outline-primary" @click="addRow('loans')">
                                    Add Row
                                </button>
                            </div>
                        </div>
                        <div>
                            <hr />
                            <p class="card-text fs-17"><b>Existing Credit Cards</b></p>
                            <p class="card-text text-justify">Do you have existing credit cards?</p>
                            <div class="row">
                                <div class="col-4">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="c5" value="Y" v-model="ccardQ" @input="num_credit_cards=''">
                                        <label for="c5" :class="{ 'text-danger': submitting && $v.ccardQ.$error }">Yes</label>
                                    </div>
                                </div>
                                <div class="col-8">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="c6" value="N" v-model="ccardQ" @input="resetRow('ccards'), num_credit_cards=0">
                                        <label for="c6" :class="{ 'text-danger': submitting && $v.ccardQ.$error }">No</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="ccardQ=='Y'">
                            <hr />
                            <div class="row">
                                <div class="col-md-3 form-group">
                                    <label for="cc0">No. of Existing Credit Cards<b class="danger fs-17">*</b></label>
                                    <input id="cc0" type="number" class="form-control form-control-sm" v-model="num_credit_cards" />
                                </div>
                            </div>
                            <p class="card-text text-justify">Please indicate top 3 in terms of credit limit</p>

                            <div class="row" v-for="(i, k) in ccards" :key="k">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label :for="'cca'+k">Name of Financial Institution</label>
                                        <v-select :inputId="'cca'+k" placeholder="- Select -" append-to-body :calculate-position="withPopper" label="fin_inst_desc" :options="banks" :reduce="fin_inst_desc => fin_inst_desc.id" v-model="i.fin_inst_id"></v-select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label :for="'ccb'+k">Credit Limit</label>
                                        <input :id="'ccb'+k" type="number" class="form-control form-control-sm" v-model="i.credit_limit">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label :for="'ccc'+k">Outstanding Balance</label>
                                        <input :id="'ccc'+k" type="number" class="form-control form-control-sm" v-model="i.fin_credit_ob">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div>
                                        <label :for="'ccd'+k" class="d-block">Type of Account Ownership</label>
                                        <div role="group" class="form-group" style="display: flex; align-items: center;">
                                            <select :id="'ccd'+k" class="form-control form-control-sm" v-model="i.fin_credit_own_id">
                                                <option :value="null">- Select -</option>
                                                <option v-for="(i, k) in ownership" :value="i.id" :key="k">{{i.fin_accnt_own_desc}}</option>
                                            </select>
                                            <button class="btn btn-sm btn-outline-danger ml-1" @click="removeRow(k, 'ccards')" v-if="ccards.length > 1">Remove</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-right">
                                <button class="btn btn-sm text-nowrap btn-outline-primary" @click="addRow('ccards')">
                                    Add Row
                                </button>
                            </div>
                        </div>

                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="btnSubmit()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>

        </div>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        createPopper
    } from '@popperjs/core';
    import {
        required,
    } from 'vuelidate/lib/validators';
    import {
        apiRefFinInfoRegistry,
        apiPostFinInfo
    } from "@js/api/applyLoanApi";
    export default {
        components: {},
        props: ['app_id'],
        data() {
            return {
                loanQ: null,
                emoneyQ: null,
                ccardQ: null,
                num_credit_cards: null,
                emoneys: [{
                    fin_inst_id: null,
                    fin_accnt_type_id: null,
                    year_opened: null,
                    fin_accnt_own_id: null,

                }],
                loans: [{
                    fin_inst_id: null,
                    loan_amt: null,
                    date_granted: null,
                    date_maturity: null,
                    fin_loan_ob: null,
                    coll_id: null,
                }],
                ccards: [{
                    fin_inst_id: null,
                    credit_limit: null,
                    fin_credit_ob: null,
                    fin_credit_own_id: null,
                }],

                banks: [],
                category: [],
                ownership: [],
                collateral: [],
                submitting: false,
                errors: [],
                error: 0,
                error_message: '',
                api: {
                    post: false,
                    update: false,
                    ref: false,
                },
            }
        },

        validations: {
            loanQ: {
                required
            },
            emoneyQ: {
                required
            },
            ccardQ: {
                required
            },
        },
        created() {
            this.initData();
        },
        methods: {
            checkDate(val, id) {
                let x = document.getElementById(id);
                if (!val) {
                    x.value = null;
                }
            },

            async initData() {
                this.$emit('load', 1);
                try {
                    const {
                        banks,
                        category,
                        collateral,
                        ownership
                    } = await apiRefFinInfoRegistry();
                    this.banks = banks;
                    this.category = category;
                    this.collateral = collateral;
                    this.ownership = ownership;

                } catch (error) {
                    this.$emit('error', error);
                } finally {
                    this.$emit('load', -1);
                }
            },

            btnSubmit() {
                this.submitting = true;
                this.$v.loanQ.$touch();
                this.$v.emoneyQ.$touch();
                this.$v.ccardQ.$touch();
                if (this.$v.loanQ.$invalid || this.$v.emoneyQ.$invalid || this.$v.ccardQ.$invalid) {
                    const err = {
                        response: {
                            data: {
                                message: "Please complete all required fields",
                            }
                        }
                    };
                    this.$emit('error', err);
                } else {
                    this.apiSubmit();;
                }
            },

            async apiSubmit() {
                this.$emit('load', 1);
                try {
                    const checkData = (data) => _.some(data, obj =>
                        _.some(_.values(obj), value => !_.isEmpty(value))
                    );

                    const a = checkData(this.emoneys);
                    const b = checkData(this.loans);
                    const c = checkData(this.ccards);

                    const form = {
                        application_id: this.app_id,
                        num_credit_cards: this.num_credit_cards || 0,
                        emoneys: a ? this.emoneys : null,
                        loans: b ? this.loans : null,
                        ccards: c ? this.ccards : null,
                    };

                    const res = await apiPostFinInfo(form);
                    this.$emit('next');
                } catch (error) {
                    this.$emit('error', error);
                } finally {
                    this.$emit('load', -1);
                }
            },

            resetRow(obj) {
                const x = this[obj][0];
                const y = _.mapValues(x, () => null)
                this[obj] = [y];
            },
            removeRow(index, obj) {
                this[obj].splice(index, 1);
            },
            addRow(obj) {
                if (this[obj].length < 3) {
                    switch (obj) {
                        case 'loans':
                            this.loans.push({
                                fin_inst_id: null,
                                loan_amt: null,
                                date_granted: null,
                                date_maturity: null,
                                fin_loan_ob: null,
                                coll_id: null,
                            });
                            break;
                        case 'emoneys':
                            this.emoneys.push({
                                fin_inst_id: null,
                                fin_accnt_type_id: null,
                                year_opened: null,
                                fin_accnt_own_id: null,
                            });
                            break;
                        case 'ccards':
                            this.ccards.push({
                                fin_inst_id: null,
                                credit_limit: null,
                                fin_credit_ob: null,
                                fin_credit_own_id: null,
                            });
                            break;
                    }
                }
            },
            withPopper(dropdownList, component, {
                width,
                top,
                left
            }) {

                dropdownList.style.top = top;
                dropdownList.style.left = left;
                dropdownList.style.width = width;


                const popper = createPopper(component.$refs.toggle, dropdownList, {
                    placement: 'top',
                    modifiers: [{
                            name: 'offset',
                            options: {
                                offset: [0, -1]
                            }
                        },
                        {
                            name: 'toggleClass',
                            enabled: true,
                            phase: 'write',
                            fn({
                                state
                            }) {
                                component.$el.classList.toggle('drop-up', state.placement === 'top')
                            },
                        }
                    ]
                });
                return () => popper.destroy();
            },

        },
        computed: {

        },
        mounted() {}
    }
</script>



<style scoped>

</style>